// extracted by mini-css-extract-plugin
module.exports = {"title":"_1VJZd","open":"_25CMo","collapse":"_3P8BN"};